import translationQueries from "$/lib/queries/translation-queries"
import { DEFAULT_LANGUAGE } from "@repo/common"
import { TranslationIntlProvider } from "@repo/ui/components/translation-intl-provider"
import { useSuspenseQuery } from "@tanstack/react-query"
import React from "react"

/**
 * The admin app is Swedish-only, but the @repo/ui components it renders look
 * their texts up by key, so they need the dictionary.
 */
export const TranslationProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { data: dictionary } = useSuspenseQuery(
    translationQueries.dictionary(DEFAULT_LANGUAGE),
  )

  return (
    <TranslationIntlProvider
      language={DEFAULT_LANGUAGE}
      messages={dictionary.messages}
    >
      {children}
    </TranslationIntlProvider>
  )
}
